import App from 'app/app.js';

function LtImageOrientationClassDirective() {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      element.bind('load', function (event) {
        var isPortrait = event.target.height > event.target.width;

        attrs.$removeClass(isPortrait ? 'landscape' : 'portrait');
        attrs.$addClass(isPortrait ? 'portrait' : 'landscape');
      });
    }
  };
}

App.directive('ltImageOrientationClass', [LtImageOrientationClassDirective]);
